import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/contexts/I18nContext";

const Column = ({ title, links }) => (
  <nav aria-label={title}>
    <h2 className="mb-2 font-ui text-[0.95rem] font-semibold">{title}</h2>
    <ul className="space-y-1.5">
      {links.map(([to, label]) => (
        <li key={to}><Link to={to} className="text-muted-foreground hover:text-primary">{label}</Link></li>
      ))}
    </ul>
  </nav>
);

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer className="mt-20 border-t border-border bg-secondary/40">
      <div className="mx-auto grid max-w-6xl gap-8 px-4 py-10 sm:grid-cols-2 sm:px-6 lg:grid-cols-[2fr_1fr_1fr]">
        <div>
          <p className="font-display text-xl text-primary">{t("site_name")}</p>
          <p className="mt-2 max-w-sm text-muted-foreground">{t("footer_tag")}</p>
        </div>
        <Column title={t("footer_explore")} links={[
          ["/books", t("nav_books")], ["/authors", t("nav_authors")],
          ["/publishers", t("nav_publishers")], ["/discussions", t("nav_discussions")],
        ]} />
        <Column title={t("footer_about")} links={[
          ["/about", t("footer_about_us")], ["/contact", t("footer_contact")],
          ["/privacy", t("footer_privacy")], ["/terms", t("footer_terms")],
        ]} />
      </div>
      <div className="mx-auto max-w-6xl border-t border-border px-4 py-4 text-sm text-muted-foreground sm:px-6">
        <p>© {new Date().getFullYear()} {t("site_name")}. {t("affiliate_disclosure")}</p>
      </div>
    </footer>
  );
};
